import { Component, ElementRef, ViewChild } from "@angular/core";
import { PreviewItemFilterOptionComponent } from "../preview-item-filter-option.component";
import { debounceTime, distinctUntilChanged, fromEvent, map, Subscription } from "rxjs";

@Component({
    imports: [],
    templateUrl: "./preview-item-filter-option-input.component.html"
})
export class PreviewItemFilterOptionInputComponent extends PreviewItemFilterOptionComponent {
    @ViewChild("selfText") private selfTextRef!: ElementRef<HTMLInputElement>;
    private inputEventSub?: Subscription;
    
    public constructor() {
        super();
    }

    public override ngAfterViewInit(): void {
        this.inputEventSub = fromEvent(this.selfTextRef.nativeElement, 'input')
            .pipe(map((event: Event) => (event.target as HTMLInputElement).value))
            .pipe(debounceTime(200))
            .pipe(distinctUntilChanged())
            .subscribe(_ => this.update(this.selfTextRef!.nativeElement.value!));

        super.ngAfterViewInit();
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
        this.inputEventSub?.unsubscribe();
    }

    public override loadStoredOptionValue(value: string): void {
        super.loadStoredOptionValue(value);
        this.selfTextRef.nativeElement.value = value;
    }

    public clearTextInput(): void {
        if (this.selfTextRef?.nativeElement?.value) {
            this.selfTextRef.nativeElement.value = "";
            this.update("");
        }
    }
}